import React, { useEffect, useState } from "react"
import { Box, Button, Grid, Typography, Tooltip, Collapse } from "@mui/material"
import { FaChevronDown, FaChevronLeft, FaChevronUp } from "react-icons/fa6"
import * as Style from "./style"
import { useNavigate, useParams } from "react-router-dom"
import { CiMail } from "react-icons/ci"
import { useAppliedJobsQuery } from "../../features/Auth/authApi"
import dummy from "../../images/dummy-image.jpg"
import CenteredSpinner from "../common/CenteredSpinner"
import { BsInfoCircleFill } from "react-icons/bs"

import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
  FormatYear,
} from "../common/utctolocalDate"
import { LuPhone } from "react-icons/lu"
import ExtraDetailsDisplay from "../ExtraDetailsSeeker/ExtraDetailsDisplay"
const Appliedviewtarck = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [viewApply, setViewApply] = useState<any>([])
  const [showExtraDetails, setShowExtraDetails] = useState(false)

  const { data: approvedjobs, isLoading, isFetching } = useAppliedJobsQuery({})

  useEffect(() => {
    const arrAyFilter = approvedjobs?.data?.filter(
      (item: any) => item?._id == id,
    )

    setViewApply(arrAyFilter?.[0])

    if (arrAyFilter && arrAyFilter?.[0]?._id !== id) {
      navigate("/dashboard/applied-job")
    }
  }, [approvedjobs, id])

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <Box className="pt-md-5 px-md-5">
          <Style.Overview>
            <Box className="feature-card py-4 px-2">
              <Box className="d-flex justify-content-between align-items-center pb-2">
                <Box className="d-flex align-items-center gap-4">
                  <Button
                    className="back-btn mb-0"
                    onClick={() => navigate(-1)}
                  >
                    <FaChevronLeft />
                  </Button>
                </Box>
                <Box>
                  <Typography className="status-text-2 mb-0">
                    Status-{" "}
                    <span className="completed fw-bold">
                      {(viewApply as any)?.postData?.status}
                    </span>
                  </Typography>
                </Box>
              </Box>
              <Box className="p-4 service-detail-box-lg">
                <Grid container spacing={2}>
                  {/* LEFT SIDE: 40% */}
                  <Grid item xs={12} md={5} lg={4} xl={3}>
                    <Box className="text-center d-flex flex-column align-items-center h-100 p-3 border rounded">
                      <Box className="mb-3">
                        <img
                          src={
                            (viewApply as any)?.postData?.seekerDetails
                              ?.profilePic || dummy
                          }
                          className="profile-img-2"
                          alt="profile"
                        />
                      </Box>
                      <Typography
                        variant="body1"
                        align="center"
                        className="mb-3 fw-bold"
                      >
                        {(viewApply as any)?.postData?.seekerDetails?.name}
                      </Typography>

                      <Typography
                        variant="body1"
                        className="mb-2 fw-bold d-inline-flex gap-1 align-items-center"
                      >
                        <CiMail color="#F475A4"/>
                        <span
                          style={{
                            maxWidth: "180px",
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {/* Show first 16 chars with ellipsis if longer */}
                          {(viewApply as any)?.postData?.seekerDetails?.email
                            ?.length > 16
                            ? (
                                viewApply as any
                              )?.postData?.seekerDetails?.email.slice(0, 16) +
                              "..."
                            : (viewApply as any)?.postData?.seekerDetails
                                ?.email}
                        </span>
                        <Tooltip 
                          title={
                            (viewApply as any)?.postData?.seekerDetails
                              ?.email || ""
                          }
                          arrow
                        >
                          <Button
                            style={{ minWidth: "10px" }}
                            className="m-0 p-0"
                          >
                            <BsInfoCircleFill color="#F475A4" />
                          </Button>
                        </Tooltip>
                      </Typography>

                      <Typography
                        variant="body2"
                        align="center"
                        className="d-flex fw-bold justify-content-center gap-1"
                      >
                        <LuPhone color="#F475A4" />
                        {(viewApply as any)?.postData?.seekerDetails?.contactNo}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* RIGHT SIDE: 60% */}
                  <Grid item xs={12} md={7} lg={8} xl={9}>
                    <Box
                      sx={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        paddingRight: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      {/* FIELD GROUP */}
                      {[
                        {
                          label: "Service Required",
                          value: (viewApply as any)?.postData?.jobDetails?.name,
                        },
                        {
                          label: "Number Of Providers Required",
                          value: (viewApply as any)?.postData?.personRequired,
                        },
                        // {
                        //   label: "Age Of Provider",
                        //   value: (viewApply as any)?.postData?.ageRange?.join(
                        //     "-",
                        //   ),
                        // },
                        {
                          label: "Service Date",
                          value: (() => {
                            const date = (viewApply as any)?.postData?.from
                              ? new Date((viewApply as any)?.postData?.from)
                              : null

                            const formattedDate = date?.toLocaleDateString(
                              "en-GB",
                              {
                                day: "numeric",
                                month: "long",
                                weekday: "long",
                                year: "numeric",
                              },
                            )

                            if (!formattedDate) return "-"

                            
                            const [weekday, day, month, year] =
                              formattedDate.split(" ")
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <span>{`${day} ${month}, ${weekday} ${year}`}</span>
                              </Box>
                            )
                          })(),
                        },
                        {
                          label: "Service Time",
                          value: (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <FormatChangeTime
                                dateString={(viewApply as any)?.postData?.from}
                              />
                              <span>-</span>
                              <FormatChangeTime
                                dateString={(viewApply as any)?.postData?.till}
                              />
                            </Box>
                          ),
                        },
                        {
                          label: "Language  ",
                          value: (viewApply as any)?.postData?.language?.join(
                            ", ",
                          ),
                        },
                        {
                          label: "Location",
                          value: (viewApply as any)?.postData?.location,
                        },
                        {
                          label: "Additional Instructions",
                          value: (viewApply as any)?.postData?.description,
                          condition: !!(viewApply as any)?.postData
                            ?.description,
                        },
                      ].map(
                        (field, idx) =>
                          (field.condition === undefined ||
                            field.condition) && (
                            <Box
                              key={idx}
                              className="p-3"
                              sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                background: "#fafafa",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                fontWeight={600}
                                mb={0.5}
                              >
                                {field.label}
                              </Typography>
                              <Typography variant="body2">
                                {field.value}
                              </Typography>
                            </Box>
                          ),
                      )}

                      {/* Uploaded Photos */}
                      {(viewApply as any)?.postData?.attachments?.length >
                        0 && (
                        <Box
                          className="p-3"
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            background: "#fafafa",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            mb={1}
                          >
                            Uploaded Photos
                          </Typography>
                          <Box className="d-flex flex-wrap gap-2">
                            {(viewApply as any)?.postData?.attachments?.map(
                              (img: any, idx: number) => (
                                <img
                                  key={idx}
                                  src={img || dummy}
                                  alt={`upload-${idx}`}
                                  style={{
                                    height: "48px",
                                    width: "48px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                              ),
                            )}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>

          {/* Additional Info Section - Below the service details container */}
          <Box className="py-2 px-0 bg-white my-2" sx={{ maxHeight: "500px", borderRadius: "18px" }}>  
            {viewApply?.postData?.extraDetails && (
              <Box className="px-4 mt-4">
                <Button
                  variant="outlined"
                  onClick={() => setShowExtraDetails(!showExtraDetails)}
                  className="text-capitalize d-flex align-items-center gap-2"
                  style={{
                    borderColor: "#F475A4",
                    color: "#F475A4",
                    fontWeight: "600",
                    padding: "8px 16px",
                  }}
                >
                  {showExtraDetails ? (
                    <>
                      <FaChevronUp size={14} />
                      Hide Additional Information
                    </>
                  ) : (
                    <>
                      <FaChevronDown size={14} />
                      Show Additional Information
                    </>
                  )}
                </Button>

                <Collapse in={showExtraDetails}>
                  <Box className="mt-3 p-2 border rounded">
                    <ExtraDetailsDisplay
                      extraDetails={viewApply.postData.extraDetails}
                      serviceName={viewApply.postData.jobDetails?.name}
                    />
                  </Box>
                </Collapse>
              </Box>
            )}
            {/* </Box> */}
          </Box>
          </Style.Overview>
        </Box>
      )}
    </>
  )
}
export default Appliedviewtarck
